/// <amd-module name="Dashboards/WidgetContracts/Internal/DashboardWidgetProps" />
import { SemanticVersion } from "../WidgetProps";
import { WidgetMetadataProps } from "./WidgetMetadataProps";

// Re-export LoadingStatus & LoadedEventInfo for convenience on Config Implementations
export { SemanticVersion };

/** Size, as expressed in terms of discrete dashboard grid cells. */
export interface WidgetGridSize {
    columnSpan: number;
    rowSpan: number;
}

export interface WidgetPosition {
    column: number;
    row: number;
}

/** Describes stateful, grid-aware information for use in a Widget config, and on a dashboard. */
export interface DashboardWidgetProps extends WidgetMetadataProps {
    /** (Optional) Unique identifier of widget Configuration.
     *  Can be absent with widget previews during configuration, as well as widgets hosted on non-configurable "in-situ" experiences.
     */
    id?: string;

    /**
     * User-configurable name of widget. Rendered as title.
     */
    name: string;

    /**
     * Size of Widget, expressed in grid cells.
     */
    size: WidgetGridSize;

    /**
     * Position of Widget, expressed in terms of grid location.
     */
    position: WidgetPosition;

    /**
     * Widget-defined Configuration. Supplied by Widget Configuration - default configuration is null.
     */
    settings: string | null;

    /**
     * Widget-defined settings version. Allows widget authors to recognize legacy data formats.
     */
    settingsVersion: SemanticVersion;

    /** Fully qualified Identifier of Widget Contribution. This can be helpful for scenarios such as telemetry, on codepaths shared by different widgets. */
    contributionId: string;

    /** Widget level ETag*/
    eTag?: string;

    /**Widget Level Validation*/
    hasError?: boolean;
}
